import React from 'react';
import Modal from '@omilia/modal';

import messages from 'constants/messages';
import CommitForm from '../../components/CommitForm';

type Props = {
  loading: boolean;
  onCancel: () => void;
  onSubmit: (message: string) => void;
};

const CommitFormModal = ({ loading, onCancel, onSubmit }: Props) => (
  <Modal
    open
    glyph="commit"
    hasBackdrop={false}
    subtitle="Commit & Push changes on the branch"
    title={messages.VERSION_CONTROL.MODAL.COMMIT.GENERAL_TITLE}
  >
    <CommitForm loading={loading} onCancel={onCancel} onSubmit={onSubmit} />
  </Modal>
);

export default CommitFormModal;
